import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import {AccessDeniedException, isAccessDeniedException} from "../core";
import {isFunction} from "@firefly/fly-defter";


export type AccessDeniedFallbackProps = {
    error: AccessDeniedException;
    resetErrorBoundary: FallbackProps['resetErrorBoundary'];
}
type FallbackType = React.ReactNode | ((props: AccessDeniedFallbackProps) => React.ReactNode);
export interface AccessDeniedBoundaryProps {
    resetKeys?: any[];
    fallback?: FallbackType;
    children: React.ReactNode;
}
function AccessDeniedBoundary(props: AccessDeniedBoundaryProps) {
    const {
        resetKeys,
        fallback: _fallback,
        children,
    } = props;

    function fallback(props: AccessDeniedFallbackProps): React.ReactNode {
        if (isFunction(_fallback)) {
            return _fallback(props);
        }
        return _fallback;
    }

    return <ErrorBoundary
        resetKeys={resetKeys}
        fallbackRender={(props: FallbackProps) => {
            const {
                error,
                resetErrorBoundary,
            } = props;
            if (isAccessDeniedException(error)) {
                return fallback({
                    error,
                    resetErrorBoundary
                })
            }
            throw error;
        }}
    >
        {children}
    </ErrorBoundary>

}

export default AccessDeniedBoundary;